import { html } from "lit";
var icon_sq_placeholder_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      d="M27 4a1 1 0 011 1v.326L5.024 28H5a1 1 0 01-1-1v-.8L26.496 4H27zm1 10.358v2.81L17.023 28h-2.847L28 14.358zm0 10.684V27a1 1 0 01-1 1h-1.997L28 25.042zM17.344 4L4 17.168v-2.81L14.496 4h2.848zM7.258 4L4 7.215V5a1 1 0 011-1h2.258z"
      fill-rule="evenodd" />
  </svg>
`;
export {
  icon_sq_placeholder_default as default
};
//# sourceMappingURL=icon-sq-placeholder.js.map
